import { create } from "zustand";
import { Provider, Section } from "../data/ecommerce/providers";
import { Product } from "../data/ecommerce/storeCatalog";

interface ProviderStore {
    provider: Provider | null;
    setProvider: (provider: Provider | null) => void;
    products: Product[];
    setProducts: (products: Product[]) => void;
    sections: Section[];
    setSections: (products: Section[]) => void;
}

export const useProviderStore = create<ProviderStore>((set) => ({
    provider: null,
    setProvider: (provider: Provider | null) => set({ provider }),
    products: [],
    setProducts: (products: Product[]) => set({ products }),
    sections: [],
    setSections: (sections: Section[]) => set({ sections }),
}));
